<template>
    <div class="pack-box gift-choice gift-choice__tableau "  >
    <div class="pack-title">
        <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux" />
        <h3> Choisissez votre <span class="orange-text">cadeau</span></h3>
    </div>
    <h6 class="text-uppercase orange-text">Accédez à un catalogue complet de cadeaux</h6>
    <p>
        Le consommateur devrait toujours avoir le choix. C’est pourquoi, Test
        Achats vous propose de choisir parmi un catalogue de cadeaux variés&nbsp;:
    </p>
    <div class="tableau">
        <div class="tableau-title-container">
            <p class="tableau-title">Quelques  exemples  de cadeaux </p>
<!--            <p class="product-offre tableau-title">Offre</p>-->
            <p class="product-price tableau-title">Prix</p>
        </div>
        <div class="product-row" v-for="elem in tableau">
            <p class="product-name" v-html="elem"></p>
<!--            <p class="product-offre">2€ / 2 mois</p>-->
            <p class="product-price">GRATUIT</p>
        </div>
        <div class="product-row">
            <p class="product-name">TABLETTE Lenovo <span>+ coque transparente</span>
                <svg style="margin-left: 3px" width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="0.-Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Home-PremiumTablet-BlackFriday" transform="translate(-1226.000000, -1385.000000)" fill="#FF8600">
                            <g id="compo_home_texte" transform="translate(15.000000, 842.000000)">
                                <g id="Right-bloc" transform="translate(987.000000, 206.000000)">
                                    <g id="Tableau" transform="translate(0.000000, 161.000000)">
                                        <polygon id="Star" points="231 186.5 226.885503 188.663119 227.671302 184.081559 224.342604 180.836881 228.942752 180.168441 231 176 233.057248 180.168441 237.657396 180.836881 234.328698 184.081559 235.114497 188.663119"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </p>
<!--            <p class="product-offre">2€ / 2 mois</p>-->
            <p class="product-price">92,40 €*</p>
        </div>
        <p class="asterix">* Contribution personnelle supplémentaire.
            Paiement possible par carte de crédit uniquement.</p>
    </div>
    </div>
</template>

<script>
export default {
    name: "GiftChoiceTableauLenovo",
    data() {
        return {
            tableau: [
                `MACHINE À CAFÉ <span> compatible capsules</span> `, "CASQUE JBL", "Aspirateur Robot", "SmartWatch GTS4",
            ],
        }
    },

}
</script>

<style scoped>

</style>
